import Axios, { AxiosRequestConfig, AxiosRequestHeaders } from "axios";

import store from "../lib/createStore";
import { GlobalState } from "../definitions/GlobalState";

interface AdaptAxiosRequestConfig extends AxiosRequestConfig {
  headers: AxiosRequestHeaders;
}
function authRequestInterceptor(config: AdaptAxiosRequestConfig) {
  config.headers.Accept = "application/json";
  // config.headers['Authorization'] = headers;
  return config;
}



// const axiosCRM = Axios.create({
//   baseURL: "https://unfranchisemarketing.mysecureoffice.com",
// });

// axiosCRM.interceptors.request.use(authRequestInterceptor);
// axiosCRM.interceptors.response.use(
//   (response) => {
//     return response.data;
//   },
//   (error) => {
//     const message = error.response?.data?.message || error.message;
//     // useNotificationStore.getState().addNotification({
//     //   type: 'error',
//     //   title: 'Error',
//     //   message,
//     // });
//     return Promise.reject(error);
//   }
// );

const createAxiosNewInstance = (baseURL: string) => {
  const axiosCRM = Axios.create({
    baseURL,
  });
  // axiosCRM.interceptors.request.use(authRequestInterceptor);
  // axiosCRM.defaults.headers.common['Authorization'] = headers;
  axiosCRM.interceptors.response.use(
    (response) => {
      return response.data;
    },
    (error) => {
      const message = error.response?.data?.message || error.message;
      // useNotificationStore.getState().addNotification({
      //   type: 'error',
      //   title: 'Error',
      //   message,
      // });
      return Promise.reject(error);
    }
  );

  return axiosCRM;
};

export { createAxiosNewInstance };
